// extracted by mini-css-extract-plugin
export default {"bg":"Footer_bg__VRwfl","footer":"Footer_footer__H1pvM","links":"Footer_links__7O0CB","social":"Footer_social__9utKm"};